var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: "",
        width: "400px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c("label", [
        _vm._v(
          _vm._s(_vm.$t("Partners.companyIsSettlementAgentFollowingPartners"))
        )
      ]),
      _c("label", [
        _vm._v(_vm._s(_vm.$t("Partners.disassociateAndSaveModifications")))
      ]),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-grid" },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              "locale-text-func": _vm._i18nGridLocalText,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.cList,
              "show-side-bar": false
            },
            on: {
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { no: "enterHandler", type: "primary" },
              on: { click: _vm.enterHandler }
            },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            {
              attrs: { no: "cancel" },
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }